import React, { useEffect, useState, useCallback } from 'react'
import { get } from '../../ApiServices/ApiServices';
import { useNavigate } from 'react-router';

function ActiveRentalTab() {
    const [ActivRental, setActiveRental] = useState([])
    const [RentalCurrentPage, setRentalCurrentPage] = useState(1);

    const [totalRentalItems, setTotalRentalItems] = useState(0);
    const navigate = useNavigate();

    const ActiveRental = async (pageactive) => {
        try {
            const api = `active-rentals?page_number=${pageactive}`;
            const response = await get(api);
            if (response?.status) {
                setActiveRental(response?.data?.rows);
                setTotalRentalItems(response?.data?.count);
            }
        } catch (err) {
            console.error('Error:', err);
            if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            }
        }
    };

    useEffect(() => {
        ActiveRental(RentalCurrentPage)
    }, [RentalCurrentPage]);
    useEffect(() => {
        ActiveRental();
    }, []);
    return (
        <>
            <div className="row align-items-center justify-content-between">
                <div className="col-md-6">
                    <h5>Active Rentals</h5>
                </div>
            </div>
            <div className="row mt-3">
                <div className="col-md-12">
                    <div className="table-responsive">
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th scope="col">Order #</th>
                                    <th scope="col">Customer Name</th>
                                    <th scope="col">Order Type</th>
                                    <th scope="col">Event Date</th>
                                    <th scope="col">Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {ActivRental && ActivRental.length > 0 ? (
                                    ActivRental.map((data) => (
                                        <tr key={data?.ticket || Math.random()}>
                                            <th scope="row">{data?.ticket || 'N/A'}</th>
                                            <td>
                                                {data?.user?.firstName ? `${data?.user?.firstName} ${data?.user?.lastName || ''} ` : 'N/A'}
                                            </td>
                                            <td>{data?.event_type || 'N/A'}</td>
                                            <td>{data?.current_event_date || 'N/A'}</td>
                                            <td>
                                                <span className="badge bg-outline-success">
                                                    {data?.current_order_status_name || 'N/A'}
                                                </span>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="5" className="center-text text-muted py-4">
                                            <p class="text-center">No rental data available</p>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ActiveRentalTab
